import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import styles from './styles.module.scss'

export const CallConferencePopUpButton = observer(() => {
  const { callStore, numbersStore } = useEntitiesContext()
  const store = useCallPopUpDefaultContext()
  const {
    isConference,
    isConferenceDisabled,
    handleConferenceShow,
    isConferenceParticipants,
    innerRefTooltipCurrent,
  } = store
  const label = () => {
    if (!number?.isConferenceCalling) return ''
    if (isConferenceParticipants) {
      if (isConference) {
        return 'Hide conference'
      }

      return 'Show conference'
    }

    return 'Add to call'
  }
  const number =
    callStore.contactFrom?.type === 'inbox'
      ? numbersStore.getItem(callStore.contactFrom?.numberId)
      : undefined
  const isDisabledButton = Boolean(isConferenceDisabled || !number?.isConferenceCalling)

  return (
    <div className={styles.wrap}>
      <IconButton
        size={'large'}
        color={'blue'}
        variant={'custom'}
        active={isConference}
        disabled={isDisabledButton}
        ariaLabel={`CallConferencePopUpButton_${
          isConferenceParticipants ? 'contacts' : 'userPlus'
        }`}
        onClick={() => {
          handleConferenceShow()
        }}
        iconProps={{
          icon: isConferenceParticipants ? 'contacts' : 'userPlus',
        }}
        tooltipProps={{
          label: label(),
          placement: 'top',
          zIndex: ZIndex.OVERLAY_TOP_1,
          PopperProps: {
            popperOptions: {
              modifiers: [
                {
                  name: 'preventOverflow',
                  options: {
                    boundary: innerRefTooltipCurrent,
                  },
                },
              ],
            },
          },
        }}
      />
    </div>
  )
})
